<template>
    <div class="footer-content">
        <div class="top">
            <div class="right-left">
                <div class="title">Các Trang</div>
                <div class="page" @click="handleClick('/')">Trang Chủ</div>
                <div class="page" @click="handleClick('/service')">Dịch Vụ</div>
                <div class="page" @click="handleClick('/about')">Giới Thiệu</div>
                <div class="page" @click="handleClick('/contact')">Liên Hệ</div>
            </div>
            <div class="right-left">
                <div class="title">GREENSKY SOFTWARE COMPANY LIMITED</div>
                <div class="page">
                    <img src="../assets/footerIcon1.webp" alt="">
                    Số 137/8/12, Đường ĐX 006, Khu phố 8, Phường Phú Mỹ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương, Việt
                    Nam
                </div>
                <div class="page">
                    <img src="../assets/footerIcon2.webp" alt="">
                    Tel: +84 0777189322
                </div>
                <div class="page">
                    <img src="../assets/footerIcon3.webp" alt="">
                    Mail: greensky@greensky-software.com
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2024 Bản quyền thuộc về GREENSKY SOFTWARE COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 190px;
    box-sizing: border-box;

    .top {
        color: #FFFFFF;
        background: #333333;
        display: flex;
        justify-content: space-between;
        padding: 81px 281px;

        .right-left {
            width: 450px;
            color: #FFFFFF;

            .title {
                font-weight: bold;
                font-size: 24px;
                line-height: 26px;
                text-wrap: nowrap;
                margin-bottom: 20px;
            }

            .page {
                font-weight: 400;
                font-size: 16px;
                line-height: 25px;
                margin-top: 10px;
                display: flex;
                align-items: center;

                img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 10px;
                }
            }
        }
    }

    .bottom {
        font-size: 16px;
        background: #1F1F1F;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        padding: 10px 0;
    }
}
</style>